function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function MicrophoneOffCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "29",
    height: "29",
    rx: "14.5",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3002 9.60039C12.3002 8.88431 12.5847 8.19755 13.091 7.6912C13.5974 7.18485 14.2841 6.90039 15.0002 6.90039C15.7163 6.90039 16.403 7.18485 16.9094 7.6912C17.4157 8.19755 17.7002 8.88431 17.7002 9.60039V13.2004C17.7002 13.9165 17.4157 14.6032 16.9094 15.1096C16.403 15.6159 15.7163 15.9004 15.0002 15.9004C14.2841 15.9004 13.5974 15.6159 13.091 15.1096C12.5847 14.6032 12.3002 13.9165 12.3002 13.2004V9.60039ZM15.9002 19.4374C17.3998 19.2208 18.7711 18.471 19.7629 17.3255C20.7546 16.18 21.3004 14.7155 21.3002 13.2004C21.3002 12.9617 21.2054 12.7328 21.0366 12.564C20.8678 12.3952 20.6389 12.3004 20.4002 12.3004C20.1615 12.3004 19.9326 12.3952 19.7638 12.564C19.595 12.7328 19.5002 12.9617 19.5002 13.2004C19.5002 14.3939 19.0261 15.5385 18.1822 16.3824C17.3383 17.2263 16.1937 17.7004 15.0002 17.7004C13.8067 17.7004 12.6621 17.2263 11.8182 16.3824C10.9743 15.5385 10.5002 14.3939 10.5002 13.2004C10.5002 12.9617 10.4054 12.7328 10.2366 12.564C10.0678 12.3952 9.83889 12.3004 9.6002 12.3004C9.3615 12.3004 9.13258 12.3952 8.9638 12.564C8.79502 12.7328 8.7002 12.9617 8.7002 13.2004C8.69999 14.7155 9.24578 16.18 10.2375 17.3255C11.2293 18.471 12.6006 19.2208 14.1002 19.4374V21.3004H11.4002C11.1615 21.3004 10.9326 21.3952 10.7638 21.564C10.595 21.7328 10.5002 21.9617 10.5002 22.2004C10.5002 22.4391 10.595 22.668 10.7638 22.8368C10.9326 23.0056 11.1615 23.1004 11.4002 23.1004H18.6002C18.8389 23.1004 19.0678 23.0056 19.2366 22.8368C19.4054 22.668 19.5002 22.4391 19.5002 22.2004C19.5002 21.9617 19.4054 21.7328 19.2366 21.564C19.0678 21.3952 18.8389 21.3004 18.6002 21.3004H15.9002V19.4374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "20.25",
    y1: "9.12132",
    x2: "8.37132",
    y2: "21",
    stroke: props.fill,
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21",
    y1: "8.41421",
    x2: "8.41421",
    y2: "21",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "19",
    y1: "10.5355",
    x2: "8.53553",
    y2: "21",
    stroke: props.fill,
    strokeWidth: "5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21",
    y1: "8.41421",
    x2: "8.41421",
    y2: "21",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
}
export default MicrophoneOffCircle;
//# sourceMappingURL=MicrophoneOffCircle.js.map